import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { IAppState } from '../state/app.state';
import { Store } from '@ngrx/store';
import { GetRace, ERaceActions, GetRaceSuccess } from '../actions/race.actions';
import { switchMap, map, startWith, mapTo, distinctUntilChanged } from 'rxjs/operators';
import { RaceService } from 'src/app/service/http/race/race.service';
import { IRace } from 'src/app/models/race.interface';
import { of, interval } from 'rxjs';
import { PageLoadingHide } from '../actions/page.actions';
import {EEventActions, GetEvent, GetEventSuccess, GetResetEvent} from '../actions/event.actions';

@Injectable()
export class EventEffects {

  getEvent$ = createEffect(() => this._action$.pipe(
    ofType<GetEvent>(EEventActions.GetEvent),
    switchMap((action) => interval(10000).pipe(startWith(0), mapTo(action))),
    switchMap((action) => {
        if (action.payload !== 0) {
            return this._raceService.getEvent(action.payload);
        } else {
            return of([]);
        }
    }),
    distinctUntilChanged((prev, curr) => {
      if (JSON.stringify(prev) === JSON.stringify(curr)) {
        // this._store.dispatch(new PageLoadingHide());
        return true;
      }
    }),
    switchMap((event: IRace[]) => {
        if (event.length > 0) {
            return of(new GetEventSuccess(event), new PageLoadingHide());
        } else {
            return of(new GetEventSuccess(event));
        }
    })
  ));

  constructor(private _raceService: RaceService, private _action$: Actions, private _store: Store<IAppState>) {}
}
